import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface XcRequestRmaState {
    contactName: string;
    contactEmail: string;
    contactPhone: string;
    canSendRma: boolean;
}

const initialState: XcRequestRmaState = {
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    canSendRma: false,
};

const CustomRmaData = createTypedReducerWithImmer(initialState, {
    "Custom/RequestRma/SetCanSendRma": (
        draft: Draft<XcRequestRmaState>,
        action: { canSendRma: boolean },
    ) => {
        draft.canSendRma = action.canSendRma;
    },
    "Custom/RequestRma/SetContactName": (draft: Draft<XcRequestRmaState>, action: { contactName: string }) => {
        draft.contactName = action.contactName;
    },
    "Custom/RequestRma/SetContactEmail": (draft: Draft<XcRequestRmaState>, action: { contactEmail: string }) => {
        draft.contactEmail = action.contactEmail;
    },
    "Custom/RequestRma/SetContactPhone": (draft: Draft<XcRequestRmaState>, action: { contactPhone: string }) => {
        draft.contactPhone = action.contactPhone;
    },
});

export default (reducers as any).xcentiumRma = CustomRmaData;

export type CustomRmaState = {
    xcentiumRma: XcRequestRmaState;
} & ApplicationState;

type Reducers = {
    xcentiumRmaReducer: typeof CustomRmaData;
};

export type xcentiumRmaActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
